<template>
  <div class="soundIntroduce" style="width:100%;height:100%">
    <!-- AI语音解决方案 -->
    <div class="soundSize">
      <!--      <div class="aiSoundTitle">管制语音识别产品介绍</div>-->
      <!--      <div-->
      <!--        class="aiSoundContent"-->
      <!--      >利用人工智能语音识别技术，通过将空管指令语言转化为易于识别的指令意图，为高效可靠的空管指令分析和安全应用提供基础。最终实现提升管制安全与管制效率的目的。</div>-->
      <!--      <div class="ainewChange">-->
      <!--        <div class="aiFlex">-->
      <!--          <div class="aiSoundImg aiSoundImgWidth">人声转成文字，准确率高效可靠</div>-->
      <!--          <div class="aiSoundImg aiSoundImg2 aiSoundImgWidth">机器听懂人话，识别指令意图</div>-->
      <!--          <div class="aiSoundImg aiSoundImg1">结构化、标准化、量化输出，方便进一步分析</div>-->
      <!--          <div class="aiSoundImg aiSoundImg3">定制化开发模型、服务，提供长期更新和升级支持</div>-->
      <!--        </div>-->
      <!--        <div>-->
      <!--          <video width="500" height="300" controls>-->
      <!--            <source src="../../../common/commonImages/movie.mp4" type="video/mp4">您的浏览器不支持 HTML5 video 标签。-->
      <!--          </video>-->
      <!--        </div>-->
      <!--      </div>-->
      <!-- <div class="aiSoundbackground"></div> -->
      <div class="soundSize-content">
        <div style="display: flex;justify-content: center;">
          <div class="content-top">
            安全防护
          </div>
        </div>
        <div class="content-info">
          <div>
            <div class="info-bg">
              <div class="info-img">
              </div>
                <div class="info-title">机坪管制防冲突系统</div>
            </div>
            <div class="info-content">
              本系统将管制语音识别技术融入到机坪管制指挥场景中，对管制语音进行实时识别及解析，并对关键指令进行安全检查，对于异常的情况进行预警告警，让管制员及时发现问题，快速解决安全隐患，有效保障机坪运行安全。
            </div>
          </div>
          <div style="margin-left: 140px">
            <div class="info-bg2">
              <div class="info-img2">
              </div>
              <div class="info-title">跑道防侵入系统</div>
            </div>
            <div class="info-content">
              支持声(VHF) 、光(CCTV)、电(雷达信号)信号融合，空地一体双模式行为预测，提供分钟级预警，提前发现跑道安全事件线索，道面灯光和指挥席位同步提示。
            </div>
          </div>
          <div style="margin-left: 140px">
            <div class="info-bg3">
              <div class="info-img3">
              </div>
              <div class="info-title">空中态势预警系统</div>
            </div>
            <div class="info-content">
              大空域宏观态势呈现，空域、航线布局，航线负荷及机场态势分析，航班实时航迹及相关信息监控，包含异常状况预警、航迹和事件回放，可同时为多项重大活动提供分组重点航班实时保障。
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss">

.soundSize-content {

  .content-info {
    display: flex;
    .info-content {
      width: 315px;
      font-size: 16px;
      margin-top: 30px;
    }

    .info-bg {
      background: url("../assets/jpgz.png") no-repeat;
      height: 360px;
      width: 315px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;

      .info-title {
        color: #ffffff;
        margin-top: 40px;
        font-size: 20px;
      }

      .info-img {
        width: 92px;
        height: 105px;
        background: url("../assets/jp1.png") no-repeat;
        background-position: left 54% top 30%;
      }
    }
    .info-bg2 {
      background: url("../assets/pdfrq.png") no-repeat;
      height: 360px;
      width: 315px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;

      .info-title {
        color: #ffffff;
        margin-top: 40px;
        font-size: 20px;
      }

      .info-img2 {
        width: 92px;
        height: 105px;
        background: url("../assets/pdfrq23.png") no-repeat;
        background-position: left 54% top 30%;
      }
    }
    .info-bg3 {
      background: url("../assets/kzts.png") no-repeat;
      height: 360px;
      width: 315px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;

      .info-title {
        color: #ffffff;
        margin-top: 40px;
        font-size: 20px;
      }

      .info-img3 {
        width: 92px;
        height: 105px;
        background: url("../assets/kz1.png") no-repeat;
        background-position: left 54% top 30%;
      }
    }
  }

  .content-top {
    width: 165px;
    height: 51px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-bottom: 2px solid rgb(243, 103, 65);
    font-size: 24px;
    color: rgb(243, 103, 65);
    margin-bottom: 127px;
  }
}

.ainewChange {
  display: flex;
  /* flex-direction: column; */
}

.aiSoundImgWidth {
  width: 500px;
}

.aiSoundImg {
  padding-left: 90px;
  height: 70px;
  background: url("../../../common/commonImages/ai_6.png") no-repeat;
  font-size: 20px;
  background-size: 60px 59px;
  display: flex;
  align-items: center;
  /* line-height: 60px; */

  background-position-y: center;
}

.aiSoundImg1 {
  background: url("../../../common/commonImages/ai_3.png") no-repeat;

  background-size: 58px 61px;
}

.aiSoundImg2 {
  background: url("../../../common/commonImages/ai_5.png") no-repeat;
  /* background-position-x: 6px; */
  background-size: 58px 65px;
}

.aiSoundImg3 {
  background: url("../../../common/commonImages/ai_4.png") no-repeat;

  background-size: 53px 60px;
}

.aiSoundContent {
  margin-top: 40px;
  margin-bottom: 150px;
  width: 630px;
  /* padding-left: 128px; */
  font-size: 18px;
  /* background: url("../../../common/commonImages/ai_8.png") no-repeat; */
  line-height: 30px;
  /* background-size: 88px 88px; */
}

.soundSize {
  width: 1110px;
  display: flex;
  justify-content: center;
}

.aiSoundTitle {
  width: 395px;
  height: 38px;
  font-size: 36px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 27px;
  letter-spacing: 0px;
  color: #ee6240;
}

.soundIntroduce {
  color: black;
  display: flex;
  justify-content: center;
  align-items: center;
}

.aiFlex {
  margin-right: 75px;
  display: flex;
  flex-direction: column;
  height: 315px;
  justify-content: space-between;
}
</style>

<script>
export default {
  name: "HomeSlide1",
  data() {
    return {};
  },
  created: function () {
  },
  mounted: function () {
  },
  methods: {}
};
</script>
